import type { AppearanceMode, AppearancePreferences, ResolvedAppearanceMode } from "./types";

export function resolveAppearanceMode(
  mode: AppearanceMode,
  prefersDark: boolean
): ResolvedAppearanceMode {
  if (mode === "system") {
    return prefersDark ? "dark" : "light";
  }

  return mode;
}

export function applyAppearanceToDocument(
  resolvedMode: ResolvedAppearanceMode,
  preferences: Pick<AppearancePreferences, "theme" | "font" | "fontSize">
): void {
  if (typeof document === "undefined") {
    return;
  }

  const root = document.documentElement;
  root.classList.toggle("dark", resolvedMode === "dark");
  root.dataset.theme = preferences.theme;
  root.dataset.font = preferences.font;
  root.dataset.fontSize = preferences.fontSize;
  delete root.dataset.color;
  delete root.dataset.structure;
  delete root.dataset.accent;
}
